export const catalogCenterZh = {
  resourceSpace: "资源空间",
  resourceSpaceNote: "进入个人与共享资源空间，管理上传文件、品牌资源与共享素材。",
  accountCenter: "账号中心",
  accountCenterNote: "统一身份用户的账号信息与个人设置入口。",
  businessCategory: "业务入口",
  platformEntryCategory: "平台入口",
  platformCenterCategory: "平台中心",
  platformCapabilityCategory: "平台能力",
  platformInfrastructureCategory: "平台基础设施",
  examAdminName: "考试业务后台",
  examAdminNote: "题库、试卷、考试、阅卷与考务管理。",
  candidateName: "考试考生端",
  candidateNote: "考试入口、作答、交卷与结果查询。",
  microLabName: "微实验",
  microLabNote: "微实验广场与实验运行入口，直连统一身份、资产中心与执行底座。",
  eduAdminName: "教学后台",
  eduAdminNote: "课程、教学计划、培训项目、成员与公开课治理入口。",
  eduName: "教学学习端",
  eduNote: "公开课程学习、指派学习、培训项目与个人学习入口。",
  aitestName: "测试靶场",
  aitestNote: "最小平台接入验证应用，直连统一身份、资产中心与执行底座。",
  redblueAdminName: "红蓝对抗管理端",
  redblueAdminNote: "红蓝演练方案、活动、导演台、裁判台与态势复盘管理入口。",
  redblueName: "红蓝对抗用户端",
  redblueNote: "红蓝演练参与、工作台、观测与报告入口。",
  portalName: "AIRange 门户",
  portalNote: "统一门户、应用导航与主入口承载位。",
  platformAdminName: "平台后台",
  platformAdminNote: "平台控制面管理后台，不承载考试业务页。",
  ssoName: "统一身份中心",
  ssoNote: "统一登录、会话、应用接入与身份策略。",
  assetsName: "资产中心",
  assetsNote: "对象存储、元数据与授权控制。",
  environmentNote: "统一管理环境规格、镜像、模板与拓扑素材。",
  executionName: "执行底座",
  executionNote: "容器运行时、实例编排与执行控制面。",
  taskCenterName: "任务中心",
  taskCenterNote: "任务状态口径、事件观测与失败码治理面。",
  instanceCenterNote: "统一查看实例运行态、远程连接与实例级操作记录。",
  orchestratorCenterNote: "统一查看环境编排请求、回收流程与编排动作。",
  intelligenceCenterNote: "统一管理模型连接、提供商配置、任务运行与审计日志。",
  capabilityGraphNote: "统一查看能力图谱、KSA 分类与能力关系。",
  tacticsTechniquesHubNote: "统一查看战术技法框架、矩阵映射与绑定演练。",
  vulnerabilityLibraryNote: "统一管理 CVE、CNVD 等官方漏洞编号条目与内部统一漏洞记录。",
  businessReferenceCenterNote: "统一登记跨业务资源引用、反查关系和删除前保护检查。",
  trafficLibraryNote: "统一登记流量包文件、一级分类与资产中心文件引用。",
  toolsLibraryNote: "统一管理系统内工具文件、一级分类与下载入口。",
  examApiName: "Exam API",
  examApiNote: "考试业务专用公开 API，当前公开入口由服务入口注册表解析。",
  registryNote: "统一查看平台镜像仓库接入与可用性。",
} as const;
